import {useEffect, useState} from 'react';
import type {JSX} from 'react';
import {useLocation} from 'react-router-dom';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {Toaster} from './ui/sonner';
import {Btn, Spinner} from './Shared';
import {NewTicketModal} from './NewTicketModal';
import {WorkspaceSidebar} from './WorkspaceSidebar';
import {WorkspaceHeader} from './WorkspaceHeader';
import {WorkspaceRoutes} from './WorkspaceRoutes';

export const WorkspaceShell = (): JSX.Element => {
  const {loading, error, aiSettings, newOpen, setNewOpen, retry} = useWorkspace();
  const [menuOpen, setMenuOpen] = useState(false);
  const {pathname} = useLocation();
  useEffect(() => { setMenuOpen(false); }, [pathname, setMenuOpen]);
  if (loading) return <div className="boot-screen" role="status" aria-live="polite" data-testid="workspace-loading"><Spinner/>Opening your workspace…</div>;
  if (error) return <div className="page-error" role="alert" data-testid="workspace-error"><h2 data-testid="workspace-error-title">Couldn’t open your workspace</h2><p className="section-subtitle" data-testid="workspace-error-message">{error}</p><Btn data-testid="workspace-retry" onClick={retry}>Try again</Btn></div>;
  return <><div className="app-shell"><WorkspaceSidebar open={menuOpen}/><main className="main-shell">
    <WorkspaceHeader pathname={pathname} onMenuToggle={() => setMenuOpen(open => !open)}/>
    {!aiSettings && <div className="startup-service-notice" role="status" data-testid="ai-settings-unavailable">AI settings are unavailable. Your tickets and help articles are still accessible; reload before generating a reply.</div>}
    <WorkspaceRoutes/>
  </main></div><NewTicketModal open={newOpen} onClose={() => setNewOpen(false)}/><Toaster position="bottom-right" theme="dark" richColors/></>;
};